var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRevenueVsForecast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 130,
    viewBox: "0 0 206 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 160.5H0.5V6C0.5 2.96243 2.96244 0.5 6 0.5H200C203.038 0.5 205.5 2.96244 205.5 6V160.5Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6072 31.536V118.806",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.291 31.536V118.263",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2729 31.536V118.263",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.291 31.536V118.263",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.273 31.536V118.263",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.255 31.536V118.263",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.606 118.551H178.146",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6067 100.445H178.145",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6067 82.0836H178.145",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6067 63.7224H178.145",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6067 45.3612H178.145",
    stroke: "#EEECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9356 103.474L42.5 111V119L175 118V67H163.064L152.002 78.2895H138.902L127.549 96.2368L115.031 82.6316L104.26 85.8158L91.16 94.7895L80.3889 93.3421L68.7444 102.895L55.9356 103.474Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 111L56.4356 103.474L69.2444 102.895L80.8889 93.3421L91.66 94.7895L104.76 85.8158L115.531 82.6316L128.049 96.2368L139.402 78.2895H152.502L163.564 67H175.5",
    stroke: "#CDCDCD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 84.6535H46.3341L55.6704 94L68.216 79.6881H79.5947L91.8486 70.0495L103.811 69.1733L117.232 55.7376L127.151 50.7723H139.114L149.325 42.5941L163.038 43.7624L175 35",
    stroke: "#CDCDCD",
    strokeWidth: 2,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4091 99.2727C24.0786 99.2727 23 100.351 23 101.682V101.682C23 103.012 24.0786 104.091 25.4091 104.091H32.1666C33.4971 104.091 34.5757 103.012 34.5757 101.682V101.682C34.5757 100.351 33.4971 99.2727 32.1666 99.2727H25.4091Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4091 81.9272C24.0786 81.9272 23 83.0058 23 84.3363V84.3363C23 85.6668 24.0786 86.7454 25.4091 86.7454H32.1666C33.4971 86.7454 34.5757 85.6668 34.5757 84.3363V84.3363C34.5757 83.0058 33.4971 81.9272 32.1666 81.9272H25.4091Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4091 64.5818C24.0786 64.5818 23 65.6604 23 66.9909V66.9909C23 68.3214 24.0786 69.4 25.4091 69.4H32.1666C33.4971 69.4 34.5757 68.3214 34.5757 66.9909V66.9909C34.5757 65.6604 33.4971 64.5818 32.1666 64.5818H25.4091Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4091 47.2364C24.0786 47.2364 23 48.315 23 49.6455V49.6455C23 50.976 24.0786 52.0546 25.4091 52.0546H32.1666C33.4971 52.0546 34.5757 50.976 34.5757 49.6455V49.6455C34.5757 48.315 33.4971 47.2364 32.1666 47.2364H25.4091Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4091 113.727C24.0786 113.727 23 114.806 23 116.136V116.136C23 117.467 24.0786 118.545 25.4091 118.545H32.1666C33.4971 118.545 34.5757 117.467 34.5757 116.136V116.136C34.5757 114.806 33.4971 113.727 32.1666 113.727H25.4091Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9181 121.436C63.5876 121.436 62.509 122.515 62.509 123.845V123.845C62.509 125.176 63.5876 126.255 64.9181 126.255H71.6756C73.0061 126.255 74.0847 125.176 74.0847 123.845V123.845C74.0847 122.515 73.0061 121.436 71.6756 121.436H64.9181Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4091 121.436C38.0786 121.436 37 122.515 37 123.845V123.845C37 125.176 38.0786 126.255 39.4091 126.255H46.1666C47.4971 126.255 48.5757 125.176 48.5757 123.845V123.845C48.5757 122.515 47.4971 121.436 46.1666 121.436H39.4091Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9001 121.436C90.5696 121.436 89.491 122.515 89.491 123.845V123.845C89.491 125.176 90.5696 126.255 91.9001 126.255H98.6576C99.9881 126.255 101.067 125.176 101.067 123.845V123.845C101.067 122.515 99.9881 121.436 98.6576 121.436H91.9001Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.882 121.436C117.551 121.436 116.473 122.515 116.473 123.845V123.845C116.473 125.176 117.551 126.255 118.882 126.255H125.639C126.97 126.255 128.048 125.176 128.048 123.845V123.845C128.048 122.515 126.97 121.436 125.639 121.436H118.882Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.864 121.436C144.533 121.436 143.455 122.515 143.455 123.845V123.845C143.455 125.176 144.533 126.255 145.864 126.255H152.621C153.952 126.255 155.03 125.176 155.03 123.845V123.845C155.03 122.515 153.952 121.436 152.621 121.436H145.864Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.845 121.436C171.515 121.436 170.436 122.515 170.436 123.845V123.845C170.436 125.176 171.515 126.255 172.845 126.255H179.603C180.933 126.255 182.012 125.176 182.012 123.845V123.845C182.012 122.515 180.933 121.436 179.603 121.436H172.845Z",
    fill: "#D1D3D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 108.75,
    y1: 67,
    x2: 108.75,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueVsForecast);
export default __webpack_public_path__ + "static/media/RevenueVsForecast.84dc74b06dae7c841b4194eff2baeb83.svg";
export { ForwardRef as ReactComponent };